const codes = {
  PHONE: 'PHONE'
};

export default codes;